import { Directive, Injectable } from '@angular/core';
import { ModalService } from '../../services/modal/modal.service';

@Directive()
export abstract class BaseModalComponent {
  data;
  constructor(protected modalService: ModalService) {}
  abstract confirm();
  abstract cancel();
}
